"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _TreeSet = _interopRequireDefault(require("../../../../../../java/util/TreeSet"));

var _GeometryTransformer2 = _interopRequireDefault(require("../../../geom/util/GeometryTransformer"));

var _hasInterface = _interopRequireDefault(require("../../../../../../hasInterface"));

var _Double = _interopRequireDefault(require("../../../../../../java/lang/Double"));

var _LineStringSnapper = _interopRequireDefault(require("./LineStringSnapper"));

var _PrecisionModel = _interopRequireDefault(require("../../../geom/PrecisionModel"));

var _Polygonal = _interopRequireDefault(require("../../../geom/Polygonal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var GeometrySnapper =
/*#__PURE__*/
function () {
  function GeometrySnapper() {
    _classCallCheck(this, GeometrySnapper);

    GeometrySnapper.constructor_.apply(this, arguments);
  }

  _createClass(GeometrySnapper, [{
    key: "snapTo",
    value: function snapTo(snapGeom, snapTolerance) {
      var snapPts = this.extractTargetCoordinates(snapGeom);
      var snapTrans = new SnapTransformer(snapTolerance, snapPts);
      return snapTrans.transform(this._srcGeom);
    }
  }, {
    key: "snapToSelf",
    value: function snapToSelf(snapTolerance, cleanResult) {
      var snapPts = this.extractTargetCoordinates(this._srcGeom);
      var snapTrans = new SnapTransformer(snapTolerance, snapPts, true);
      var snappedGeom = snapTrans.transform(this._srcGeom);
      var result = snappedGeom;

      if (cleanResult && (0, _hasInterface.default)(result, _Polygonal.default)) {
        result = snappedGeom.buffer(0);
      }

      return result;
    }
  }, {
    key: "computeSnapTolerance",
    value: function computeSnapTolerance(ringPts) {
      var minSegLen = this.computeMinimumSegmentLength(ringPts);
      var snapTol = minSegLen / 10;
      return snapTol;
    }
  }, {
    key: "extractTargetCoordinates",
    value: function extractTargetCoordinates(g) {
      var ptSet = new _TreeSet.default();
      var pts = g.getCoordinates();

      for (var i = 0; i < pts.length; i++) {
        ptSet.add(pts[i]);
      }

      return ptSet.toArray(new Array(0).fill(null));
    }
  }, {
    key: "computeMinimumSegmentLength",
    value: function computeMinimumSegmentLength(pts) {
      var minSegLen = _Double.default.MAX_VALUE;

      for (var i = 0; i < pts.length - 1; i++) {
        var segLen = pts[i].distance(pts[i + 1]);
        if (segLen < minSegLen) minSegLen = segLen;
      }

      return minSegLen;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return GeometrySnapper;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "snap",
    value: function snap(g0, g1, snapTolerance) {
      var snapGeom = new Array(2).fill(null);
      var snapper0 = new GeometrySnapper(g0);
      snapGeom[0] = snapper0.snapTo(g1, snapTolerance);
      var snapper1 = new GeometrySnapper(g1);
      snapGeom[1] = snapper1.snapTo(snapGeom[0], snapTolerance);
      return snapGeom;
    }
  }, {
    key: "computeOverlaySnapTolerance",
    value: function computeOverlaySnapTolerance() {
      if (arguments.length === 1) {
        var g = arguments[0];
        var snapTolerance = GeometrySnapper.computeSizeBasedSnapTolerance(g);
        var pm = g.getPrecisionModel();

        if (pm.getType() === _PrecisionModel.default.FIXED) {
          var fixedSnapTol = 1 / pm.getScale() * 2 / 1.415;
          if (fixedSnapTol > snapTolerance) snapTolerance = fixedSnapTol;
        }

        return snapTolerance;
      } else if (arguments.length === 2) {
        var g0 = arguments[0],
            g1 = arguments[1];
        return Math.min(GeometrySnapper.computeOverlaySnapTolerance(g0), GeometrySnapper.computeOverlaySnapTolerance(g1));
      }
    }
  }, {
    key: "computeSizeBasedSnapTolerance",
    value: function computeSizeBasedSnapTolerance(g) {
      var env = g.getEnvelopeInternal();
      var minDimension = Math.min(env.getHeight(), env.getWidth());
      var snapTol = minDimension * GeometrySnapper.SNAP_PRECISION_FACTOR;
      return snapTol;
    }
  }, {
    key: "snapToSelf",
    value: function snapToSelf(geom, snapTolerance, cleanResult) {
      var snapper0 = new GeometrySnapper(geom);
      return snapper0.snapToSelf(snapTolerance, cleanResult);
    }
  }]);

  return GeometrySnapper;
}();

exports.default = GeometrySnapper;

GeometrySnapper.constructor_ = function () {
  this._srcGeom = null;
  var srcGeom = arguments[0];
  this._srcGeom = srcGeom;
};

GeometrySnapper.SNAP_PRECISION_FACTOR = 1e-9;

var SnapTransformer =
/*#__PURE__*/
function (_GeometryTransformer) {
  _inherits(SnapTransformer, _GeometryTransformer);

  function SnapTransformer() {
    var _this;

    _classCallCheck(this, SnapTransformer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SnapTransformer).call(this));
    SnapTransformer.constructor_.apply(_assertThisInitialized(_this), arguments);
    return _this;
  }

  _createClass(SnapTransformer, [{
    key: "snapLine",
    value: function snapLine(srcPts, snapPts) {
      var snapper = new _LineStringSnapper.default(srcPts, this._snapTolerance);
      snapper.setAllowSnappingToSourceVertices(this._isSelfSnap);
      return snapper.snapTo(snapPts);
    }
  }, {
    key: "transformCoordinates",
    value: function transformCoordinates(coords, parent) {
      var srcPts = coords.toCoordinateArray();
      var newPts = this.snapLine(srcPts, this._snapPts);
      return this._factory.getCoordinateSequenceFactory().create(newPts);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return SnapTransformer;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return SnapTransformer;
}(_GeometryTransformer2.default);

SnapTransformer.constructor_ = function () {
  this._snapTolerance = null;
  this._snapPts = null;
  this._isSelfSnap = false;

  if (arguments.length === 2) {
    var snapTolerance = arguments[0],
        snapPts = arguments[1];
    this._snapTolerance = snapTolerance;
    this._snapPts = snapPts;
  } else if (arguments.length === 3) {
    var _snapTolerance = arguments[0],
        _snapPts = arguments[1],
        isSelfSnap = arguments[2];
    this._snapTolerance = _snapTolerance;
    this._snapPts = _snapPts;
    this._isSelfSnap = isSelfSnap;
  }
};